import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AppHeader from './AppHeader';

export default function PrivacyStatement() {
  const theme = useTheme();
  return (

    <Box
      sx={{
        height: '100%',
        width: '100%',
        backgroundColor: '#3B4E68',
        display: 'flex',
        flexDirection: 'column',
        // justifyContent: 'space-between',
        paddingBottom: '20px',
        // overflowX: 'scroll',
      }}
    >

      <Box>
        <AppHeader />
      </Box>

      <Box
        sx={{
          height: '100%',
          width: '100%',
          backgroundColor: '#3B4E68',
          display: 'flex',
          flexDirection: 'column',
          // justifyContent: 'space-between',
          paddingBottom: '20px',
          overflowX: 'scroll',
          contain: 'size',
        }}
      >

        <Typography
          variant='body1'
          sx={{
            color: '#FFFFFF',
            fontSize: '24px',
            fontWeight: 'bold',
            textAlign: 'left',
            paddingLeft: '20px',
          }}
        >
          Privacy Statement
        </Typography>

        <Box
          sx={{
            color: '#FFFFFF',
            textAlign: 'left',
            fontSize: '14px',
            // paddingRight: '10px',
            padding: '20px',
          }}
        >
          <Typography
            variant='body1'
            sx={{
              color: '#FFFFFF',
              fontSize: '18px',
              fontWeight: 'bold',
              textAlign: 'left',
              // paddingLeft: '20px',
            }}
          >
            Last Updated: 16 Mar 2025
          </Typography>
          {/* </Box> */}

          {/* <Box
          sx={{
            color: '#FFFFFF',
            textAlign: 'left',
            fontSize: '14px',
            // paddingRight: '10px',
            padding: '20px',
          }}
        > */}
          Thank you for using the Gridvault App.
          Your privacy is important to us.
          This Privacy Statement explains how we collect, use, and protect your data when you use our app.
          {/* </Box> */}
        </Box>

        <Box
          sx={{
            color: '#FFFFFF',
            textAlign: 'left',
            fontSize: '14px',
            // paddingRight: '10px',
            padding: '20px',
          }}
        >
          <Typography
            variant='body1'
            sx={{
              color: '#FFFFFF',
              fontSize: '18px',
              fontWeight: 'bold',
              textAlign: 'left',
              // paddingLeft: '20px',
            }}
          >
            1. Data We Collect
          </Typography>
          Gridvault does not collect, store, or transmit any personal data, account credentials, or authentication codes to our servers. All authentication data remains on your device.

          Information Processed on Your Device:
          Authentication Credentials: The app stores encrypted authentication credentials locally on your device.

          One-Time Passwords (OTPs): Time-based or event-based OTPs are generated on your device without being sent to external servers.

          Device Data: Gridvault may access limited device information (such as system time and security settings) to ensure secure operation.
        </Box>

        <Box
          sx={{
            color: '#FFFFFF',
            textAlign: 'left',
            fontSize: '14px',
            // paddingRight: '10px',
            padding: '20px',
          }}
        >
          <Typography
            variant='body1'
            sx={{
              color: '#FFFFFF',
              fontSize: '18px',
              fontWeight: 'bold',
              textAlign: 'left',
              // paddingLeft: '20px',
            }}
          >
            2. How We Use Your Information
          </Typography>
          The Gridvault App functions as a local authenticator for two-factor authentication (2FA). The data processed on your device is used solely to:

          Generate authentication codes for signing into third-party services.

          Ensure the security and integrity of the authentication process.

          We do not use your data for advertising, analytics, or tracking.
        </Box>

        <Box
          sx={{
            color: '#FFFFFF',
            textAlign: 'left',
            fontSize: '14px',
            // paddingRight: '10px',
            padding: '20px',
          }}
        >
          <Typography
            variant='body1'
            sx={{
              color: '#FFFFFF',
              fontSize: '18px',
              fontWeight: 'bold',
              textAlign: 'left',
              // paddingLeft: '20px',
            }}
          >
            3. Data Sharing and Third-Party Access
          </Typography>
          We do not share, sell, or transmit your data to third parties. All authentication processes occur locally on your device without external synchronization.
        </Box>

        <Box
          sx={{
            color: '#FFFFFF',
            textAlign: 'left',
            fontSize: '14px',
            // paddingRight: '10px',
            padding: '20px',
          }}
        >
          <Typography
            variant='body1'
            sx={{
              color: '#FFFFFF',
              fontSize: '18px',
              fontWeight: 'bold',
              textAlign: 'left',
              // paddingLeft: '20px',
            }}
          >
            4. Security
          </Typography>
          We take appropriate measures to protect your data, including:

          Local encryption of stored authentication credentials.

          Support for biometric and PIN-based security on supported devices.

          No cloud synchronization, reducing the risk of unauthorized access.
        </Box>

        <Box
          sx={{
            color: '#FFFFFF',
            textAlign: 'left',
            fontSize: '14px',
            // paddingRight: '10px',
            padding: '20px',
          }}
        >
          <Typography
            variant='body1'
            sx={{
              color: '#FFFFFF',
              fontSize: '18px',
              fontWeight: 'bold',
              textAlign: 'left',
              // paddingLeft: '20px',
            }}
          >
            5. Your Choices and Control
          </Typography>
          You can delete authentication entries at any time within the app.

          Uninstalling the app removes all stored authentication credentials from your device.

          If using biometric or PIN-based security, you can disable these features in your device settings.
        </Box>

        <Box
          sx={{
            color: '#FFFFFF',
            textAlign: 'left',
            fontSize: '14px',
            // paddingRight: '10px',
            padding: '20px',
          }}
        >
          <Typography
            variant='body1'
            sx={{
              color: '#FFFFFF',
              fontSize: '18px',
              fontWeight: 'bold',
              textAlign: 'left',
              // paddingLeft: '20px',
            }}
          >
            6. Changes to This Privacy Statement
          </Typography>
          We may update this Privacy Statement from time to time. Any changes will be reflected within the app and our website. Continued use of the app after an update constitutes acceptance of the revised Privacy Statement.
        </Box>

        <Box
          sx={{
            color: '#FFFFFF',
            textAlign: 'left',
            fontSize: '14px',
            // paddingRight: '10px',
            padding: '20px',
          }}
        >
          <Typography
            variant='body1'
            sx={{
              color: '#FFFFFF',
              fontSize: '18px',
              fontWeight: 'bold',
              textAlign: 'left',
              // paddingLeft: '20px',
            }}
          >
            7. Contact Us
          </Typography>
          If you have any questions or concerns about this Privacy Statement, please contact us at:
          <br />
          Email: [support@gridvault.co.uk]
          <br />
          Website: [www.gridvault.co.uk]
        </Box>
      </Box >
    </Box>

  );
}